 // SCROLLBAR

import Scrollbar from 'smooth-scrollbar';
// import OverscrollPlugin from 'smooth-scrollbar/plugins/overscroll';
// Scrollbar.use(OverscrollPlugin);

// let fixedEls = [$(".outer--fixed")]
let scrollbar;

scrollbar = Scrollbar.init($("body")[0], {
  plugins: {
    // overscroll: {},
  },
});


$("#toTop").on("click", () => { 
  scrollbar.scrollTo(0, 0, 1000);
});

if ($(".form__content").length > 0) {
  let scrollbarPopup = Scrollbar.init($(".form__content")[0], {
    continuousScrolling: false,
    alwaysShowTracks: true,
  });
}


let $followUp;

if ($(".followUp").length > 0) {
  let $followUp = $(".followUp");

  scrollbar.addListener(function(status) {
    var offsetTop = status.offset.y;
    if (offsetTop >= 420) {
      $followUp.addClass("sticked");
      $followUp.css({
        top: 0 + 'px',
        transform: 'translate3d(0px,'+offsetTop+'px,0px)',
      })
    } else {
      $followUp.removeClass("sticked");
      $followUp.css({
        top: 420+'px',
        transform: 'translate3d(0px,'+0+'px,0px)',
      })
    }

    let panel = [];
    $(".scrollLink").each( function() {
      panel.push($(this).data("scroll-link"));
    })

    for (let i = 0, l = panel.length; i < l; i++) {
      if (offsetTop > $(panel[i])[0].offsetTop - 120) {
        $(".scrollLink").removeClass("active");
        $(".scrollLink").eq(i).addClass("active");
      }
    }
  });
}


// if ($(".followPopup").length > 0) {

  scrollbar.addListener(function(status) {
    var offsetTop = status.offset.y;
    if ($(".followPopup").length > 0) {
      let $followPopup = $(".followPopup");
      if (offsetTop >= 0) {
        $followPopup.addClass("sticked");
        $followPopup.css({
          top: 0 + 'px',
          transform: 'translate3d(0px,'+offsetTop+'px,0px)',
        })
      } else {
        $followPopup.removeClass("sticked");
        $followPopup.css({
          top: 0+'px',
          transform: 'translate3d(0px,'+0+'px,0px)',
        })
      }
    }
  });
// }

if ($(".followIfMobile").length > 0) {

  scrollbar.addListener(function(status) {
    var offsetTop = status.offset.y;
    let $followPopup = $(".followIfMobile");
    // console.log(offsetTop, );
    if ((offsetTop >= 0) && ($("body").outerWidth() < 1000)) {
      $followPopup.addClass("sticked");
      $followPopup.css({
        top: 0 + 'px',
        transform: 'translate3d(0px,'+offsetTop+'px,0px)',
      })
    } else {
      $followPopup.removeClass("sticked");
      $followPopup.css({
        top: 0+'px',
        transform: 'translate3d(0px,'+0+'px,0px)',
      })
    }
  });

}




$(".scrollLink").each( function(){
  $(this).on("click", function(e){
    e.preventDefault();
    // console.log($($(this).data("scroll-link"))[0]);
    scrollbar.scrollIntoView($($(this).data("scroll-link"))[0], {
      offsetTop: 100
    })
  })
});

// LAZYLOAD

import 'lazysizes';

// CAROUSEL

import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';

let coverSlide; 

if ($(".cover-type--multiple").length > 0) {
  var galleryThumbs = new Swiper('.swiper-container--cover-thumbnail', {
    // spaceBetween: 10,
    centeredSlides: true,
    // slidesPerView: 'auto',
    touchRatio: 0.2,
    slideToClickedSlide: true, 
    loop: true,
    autoplay: {delay: 5000},
    loopedSlides: 4,
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 50
      },
      350: {
        slidesPerView: 2.5,
        spaceBetween: 50
      },
      700: {
        slidesPerView: 4,
        spaceBetween: 50
      },
      1000: {
        slidesPerView: 5,
        spaceBetween: 10
      }
    }

  });
  var galleryTop = new Swiper('.swiper-container--cover', {
    spaceBetween: 10,
    loop: true,
    loopedSlides: 4
  });

  galleryTop.controller.control = galleryThumbs;
  galleryThumbs.controller.control = galleryTop;
}

// SELECT

import "select2";
import "select2/dist/css/select2.css";

$('.form-control > select').each(function(){
  $(this).select2({
    minimumResultsForSearch: Infinity
  }); 
});
